var $fd0e9ef6a7fe0ec9$exports = {};
$fd0e9ef6a7fe0ec9$exports = {
    "longPressMessage": `Dugo pritisnite ili pritisnite Alt + strelicu prema dolje za otvaranje izbornika`
};


export {$fd0e9ef6a7fe0ec9$exports as default};
//# sourceMappingURL=hr-HR.module.js.map
